<div
  class="modal-overlay"
  *ngIf="open"
  (click)="onBackdropClick($event)"
>
  <div
    class="modal-container"
    role="dialog"
    [attr.aria-modal]="true"
    [attr.aria-labelledby]="'confirm-dialog'"
    [attr.aria-describedby]="'confirm-desc'"
    (click)="$event.stopPropagation()"
  >
    <div class="modal-content">
      <div class="{{ headerClass }}" >
        <p class="modal-title">{{ title | i18n }}</p>
        <i *ngIf="dismissible" class="bi bi-x-circle close-icon" (click)="onCancelClick()" aria-hidden="true"></i>
      </div>

      <div class="modal-body">
        <p [innerHTML]="message | i18n"></p>
      </div>

      <div class="modal-footer">
        <button
          *ngIf="dismissible"
          type="button"
          class="btn btn-secondary"
          (click)="onCancelClick()"
        >
          {{ cancelText | i18n }}
        </button>
        <button
          type="button"
          class="btn btn-primary"
          #confirmBtn
          (click)="onConfirm()"
        >
          {{ confirmText | i18n }}
        </button>

      </div>
    </div>
  </div>
</div>